import service from "../../services/gestionTiempos/changeSettlementModel";

export default {
  namespaced: true,
  state: {
    service: new service(),
    date: null,
    model: [],
    new: {},
    modelEmployed: [],
    modelGroup: [],
    editModel: [],
    deleteItem: [],
  },
  mutations: {
    setDate(state, data) {
      state.date = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setModelEmployed(state, data) {
      state.modelEmployed = data;
    },
    setModelGroup(state, data) {
      state.modelGroup = data;
    },
    setEditModel(state, data) {
      state.editModel = data;
    },
    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
  },
  actions: {
    async newSettlementModel({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.new(state.new).then(() => {
            let items = state.new;
            commit("setNew", items);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async getModelEmployed({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.getModelEmployed();
          commit("setModelEmployed", { item });
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async getModelGroup({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.getModelGroup();
          commit("setModelGroup", { item });
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async editModel({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.edit(state.editModel);
          commit("setEditModel", { item });
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async delete({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.delete(state.deleteItem).then(() => {
            const deleteitem = state.deleteItem;
            commit("setDeleteItem", deleteitem);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
  },
};
